// extracted by mini-css-extract-plugin
module.exports = {"error":"errorPage_error__2MfkG","error-msg":"errorPage_error-msg__2fSLj"};